import type {ContentListItem, DeliveryActionPayload} from 'src/api/types'

export type ListItemActionPayload = DeliveryActionPayload & {
  action: {type: string; title?: string}
}

// Веб пока не умеет обрабатывать open_form (native-форма редактирования),
// поэтому такие action не должны давать кликабельных кнопок (CARGODEV-85806)
const UNSUPPORTED_ACTION_TYPES = ['open_form']

function isActionPayload(
  payload: ContentListItem['general_payload'] | ContentListItem['trail_payload'],
): payload is ListItemActionPayload {
  return Boolean(payload && 'action' in payload && payload.action)
}

export function getActionPayload(
  item: Pick<ContentListItem, 'general_payload' | 'trail_payload'>,
): ListItemActionPayload | undefined {
  const {general_payload, trail_payload} = item
  const actionPayload = isActionPayload(general_payload)
    ? general_payload
    : isActionPayload(trail_payload)
      ? trail_payload
      : undefined

  if (!actionPayload || UNSUPPORTED_ACTION_TYPES.includes(actionPayload.action.type)) {
    return undefined
  }

  return actionPayload
}
